var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    _vm._l(_vm.allowedItems, function(item) {
      return _c(
        "li",
        {
          class: item.htmlClass,
          attrs: { id: item.htmlId },
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.$el.classList.toggle("active")
            }
          }
        },
        [
          item.url
            ? _c("a", { attrs: { href: item.url, target: item.htmlTarget } }, [
                _c("span", [_vm._v(_vm._s(item.title))])
              ])
            : item.pageUrl
            ? _c(
                "router-link",
                { attrs: { to: item.pageUrl, target: item.htmlTarget } },
                [_c("span", [_vm._v(_vm._s(item.title))])]
              )
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }